import { axios } from '@/utils/axios'

// 获取航班
export async function queryDelayFlight (params) {
  try {
    return await axios.post('/api/delayFlight/queryDelayFlight', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 发送邮件
export async function sendEmail (params) {
  try {
    return await axios.post('/api/delayFlight/sendEmail', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 返回下载地址
export async function sendImgData (params) {
  try {
    return await axios.post('/api/delayFlight/sendImgData', params)
  } catch (error) {
    return Promise.reject(error)
  }
}
